var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C31.6304 50 37.9893 47.3661 42.6777 42.6777C47.3661 37.9893 50 31.6304 50 25C50 18.3696 47.3661 12.0107 42.6777 7.32233C37.9893 2.63392 31.6304 0 25 0C18.3696 0 12.0107 2.63392 7.32233 7.32233C2.63392 12.0107 0 18.3696 0 25C0 31.6304 2.63392 37.9893 7.32233 42.6777C12.0107 47.3661 18.3696 50 25 50ZM25 12.5C26.2988 12.5 27.3438 13.5449 27.3438 14.8438V25.7812C27.3438 27.0801 26.2988 28.125 25 28.125C23.7012 28.125 22.6562 27.0801 22.6562 25.7812V14.8438C22.6562 13.5449 23.7012 12.5 25 12.5ZM21.875 34.375C21.875 33.5462 22.2042 32.7513 22.7903 32.1653C23.3763 31.5792 24.1712 31.25 25 31.25C25.8288 31.25 26.6237 31.5792 27.2097 32.1653C27.7958 32.7513 28.125 33.5462 28.125 34.375C28.125 35.2038 27.7958 35.9987 27.2097 36.5847C26.6237 37.1708 25.8288 37.5 25 37.5C24.1712 37.5 23.3763 37.1708 22.7903 36.5847C22.2042 35.9987 21.875 35.2038 21.875 34.375Z",
    fill: "#303A46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.bbeb447bd7bebb1abd39f0af6896ea68.svg";
export { ForwardRef as ReactComponent };